// ============================================================
// Leanbot IDE Event (ARDUINO)
// ============================================================
// import { nanoid } from "nanoid";
import { customAlphabet } from 'nanoid'
import { LeanbotAuth } from './AuthService.js'
// import { sleep } from "./helpers.js";

const SequenceKey = "IdeEvent_Sequence";
const IDE_idKey = "IdeEvent_ID";

// Queue
const logQueue = [];
let isProcessingQueue = false;

export function LogIdeEvent(event = {}) {
  try {
    const sequence = Number(localStorage.getItem(SequenceKey) || 0);
    localStorage.setItem(SequenceKey, sequence + 1);

    // common fields (giống prod: ide_log.js + function.js)
    event.objectname = "ide2";
    event.sequence = sequence;
    event.nguoitao = getusername();
    event.ngaytao = getLocalTime();
    event.trangthai = event.trangthai ?? 0;
  } catch (e) {
    console.warn("LogIdeEvent: init failed", e);
    return;
  }

  try {
    console.log(
        `IdeEvent
        objectpk   : ${event.objectpk}
        thongtin   : ${shorten(event.thongtin)}
        noidung    : ${shorten(event.noidung)}
        server_    : ${event.server_}
        t_phanhoi  : ${event.t_phanhoi}
        objectname : ${event.objectname}
        sequence   : ${event.sequence}
        ngaytao    : ${event.ngaytao}
        nguoitao   : ${event.nguoitao}
        trangthai  : ${event.trangthai}`
    );
  } catch (e) {
    console.warn("LogIdeEvent: console.log failed", e);
  }

  try {
    logQueue.push(event); // Push payload into queue instead of sending immediately
    startQueueProcessor(); // Trigger processing if not already running
  } catch (e) {
    console.warn("LogIdeEvent: enqueue failed", e);
  }
}

// ============================================================
// QUEUE PROCESSOR
// ============================================================

function startQueueProcessor() {
  // If already processing, do nothing; otherwise start processing
  if (isProcessingQueue) return;
  isProcessingQueue = true;
  processNextInQueue();
}

function processNextInQueue() {
  // If queue is empty, stop processing
  if (logQueue.length === 0) {
    isProcessingQueue = false;
    return;
  }

  // Take the first item from the queue
  const event = logQueue.shift();
  const payload = buildIdeLogPayload(event); // Payload giống prod (digitaltwins-service/ide: ide_log.js + function.js) để gửi log lên server
  
  // Send the request
  if(payload)
    sendIdeLogToServer(payload);

  // Schedule next item (10ms delay similar to original async function behavior)
  setTimeout(processNextInQueue, 10);
}

// ============================================================
// HELPERS
// ============================================================

function buildIdeLogPayload(event) {
  return {
    func: "87",
    body: {
      sequence: event.sequence,
      objectpk: event.objectpk,
      noidung: event.noidung,
      trangthai: event.trangthai,
      t_phanhoi: event.t_phanhoi,
      server_: event.server_,
      thongtin: event.thongtin,
      ngaytao: event.ngaytao,
      nguoitao: event.nguoitao,
      objectname: event.objectname,
    },
  };
}

// URL log API – build-time (.env.qa / .env.production qua webpack DefinePlugin), fallback prod
const IDE_LOG_API_PROD = "https://apis.leanbot.space/api/ptvlogs/post";

function sendIdeLogToServer(payload) {
  try {
    const apiUrl =
      (typeof process !== "undefined" && process.env?.VUE_APP_SSO_API_POST) ||
      (typeof window !== "undefined" && window.__IDE_LOG_URL__) ||
      IDE_LOG_API_PROD;
    if (!apiUrl) return;

    const token = LeanbotAuth.getAccessToken?.() ?? localStorage.getItem("token") ?? "";
    // const token = LeanbotAuth.getAccessToken();
    // console.log(`[IdeLog] getAccessToken: `, token);

    if (!token) return;
    const jsonString = JSON.stringify(payload);
    const str2 = jsonString.replace(/[^\x00-\x7F]/g, "?");
    const jsonRequest = typeof btoa !== "undefined" ? btoa(str2) : "";
    if (!jsonRequest) return;
    const headers = { "Content-Type": "application/json", ...LeanbotAuth.getAuthHeaders?.() };

    fetch(apiUrl, {
      method: "POST",
      headers,
      body: JSON.stringify({ jsonRequest }),
    })
      .then(async (res) => {
        const bodyText = await res.text().catch(() => "(unreadable)");
        console.log(`[IdeLog] fetch response => HTTP ${res.status} | body: ${bodyText.slice(0, 200)}`);
      })
      .catch((err) => {
        console.log(`[IdeLog] fetch error =>`, err);
      });
  } catch (_) {
    // không ném ra để không ảnh hưởng luồng chính
  }
}

function shorten(text, len = 64) {
  const normalized = String(text ?? "")
    .replace(/\r?\n+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return normalized.length > len
    ? normalized.slice(0, len)
    : normalized;
}

// Custom NanoID alphabet: use Base62 character set
// 0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz
//
// References:
// - https://en.wikipedia.org/wiki/Base62
// - https://github.com/ai/nanoid#custom-alphabet-or-size

function getIdeID() {
  if ( ! localStorage.getItem( IDE_idKey )) {
    const alphabet62 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const nanoid = customAlphabet(alphabet62, 6)
    localStorage.setItem( IDE_idKey,  nanoid() );
  }
  return  localStorage.getItem( IDE_idKey ); // Only take first 6 chars
}

function getusername() {
  return localStorage.getItem("username") + ' ' + getIdeID();
}

function getLocalTime(){ // get local time in ISO format (yyyy-mm-ddThh:mm:ssZ) (Z = +-hh:mm)
  // ref: https://stackoverflow.com/questions/12413243/javascript-date-format-like-iso-but-local
  return new Date().toLocaleString('sv',{timeZoneName:'longOffset'}).replace(' ', 'T').replace(' GMT','');
}